import { auth } from '@/api'
import tokenManager from '@/services/tokenManager'

// Function to logout the user
const logout = (context) => {
  tokenManager.logout()
  context.commit('LOGOUT') // Remove token from Vuex store
  const uri = `?redirect=${encodeURIComponent(window.location.href)}`
  window.location = `${process.env.AUTH_URL}${uri}` // Redirect to login page with current page in the query string
}

// Function to check if user is still logged in
const checkStatus = (context, status) => {
  if (status === 401) {
    // 401 not connected
    logout(context) // Log out the user
  }
  if (status === 403) {
    // 403 not required ROLE
    // Logout total to prevent redirection loop
    logout(context)
  }
  return false // User still logged in
}

const connectAs = async (context, userId) => {
  const { data } = await auth.connectAs(userId)
  tokenManager.fake(data.token)
  window.open(process.env.PRODUCTS.SURVEY, '_blank')
}

export default {
  logout,
  checkStatus,
  connectAs
}



// WEBPACK FOOTER //
// ./src/store/modules/auth/actions.js